import { Text, Tooltip } from "@chakra-ui/react";
import { useColor } from "@styles/useColor";
import { useState } from "react";

type SaplingTransactionDetailsProps = {
  memo?: string;
  isReceived?: boolean;
};

export const SaplingTransactionDetails = ({
  memo,
  isReceived = false,
}: SaplingTransactionDetailsProps) => {
  const color = useColor();
  const [isRevealed, setIsRevealed] = useState(false);

  if (!memo) {
    return null;
  }

  if (!isReceived) {
    return (
      <Text color={color("600")} fontSize="sm">
        {memo}
      </Text>
    );
  }

  return (
    <Tooltip label={isRevealed ? "Click to hide" : "Click to reveal"}>
      <Text
        color={color("600")}
        fontSize="sm"
        userSelect={isRevealed ? "auto" : "none"}
        cursor="pointer"
        filter={isRevealed ? undefined : "blur(5px)"}
        onClick={e => {
          e.stopPropagation();
          setIsRevealed(!isRevealed);
        }}
      >
        {memo}
      </Text>
    </Tooltip>
  );
};
